import { useState } from 'react';

/**
 * Hook that handles the setting/retrieving of application state
 * @param {object} initialAppState
 * @returns {[object, object]} Current app state and set functions to update state
 */
export default function useHeaderStore(initialAppState) {
  const [store, setStore] = useState({
    ...initialAppState,
    isTopBarVisible: true,
    isScrimOpen: false,
    isSearchOpen: false,
  });

  const [actions] = useState({
    setTopBarIsVisible: isTopBarVisible => {
      setStore(prevState => {
        return { ...prevState, isTopBarVisible };
      });
    },
    setIsLoggedIn: isLoggedIn => {
      setStore(prevState => {
        return { ...prevState, identity: { ...prevState.identity, isLoggedIn } };
      });
    },
    setUserProfile: userProfile => {
      setStore(prevState => {
        return { ...prevState, identity: { ...prevState.identity, userProfile } };
      });
    },
    setIsScrimOpen: isScrimOpen => setStore(state => ({ ...state, isScrimOpen })),
    setIsSearchOpen: isSearchOpen => setStore(state => ({ ...state, isSearchOpen })),
  });

  return [store, actions];
}
